import { getRowId } from './getRowId';

type SelectAllSelection = {
  selectedRows: any[];
  selectedVirtualRows: number;
};

// Rebuilds the select-all selection against whatever is currently loaded:
// every loaded row minus the exclusions, with the rest of the dataset left as
// a virtual count. Pure and idempotent, so it is safe on both a lazy append
// and a full replace (sort / filter / reload).
export const resolveSelectAllSelection = (
  data: any[],
  totalCount: number,
  deselectedRowIds: Set<string>,
  dataKey: string
): SelectAllSelection => {
  const selectedRows = data.filter((row) => {
    const id = getRowId(row, dataKey);
    return id === null || !deselectedRowIds.has(id);
  });

  return {
    selectedRows,
    selectedVirtualRows: Math.max(
      0,
      totalCount - deselectedRowIds.size - selectedRows.length
    ),
  };
};
